module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/012-sao-tome-and-prince-bea8f0ccda3c5badaab05f386a42a7d6.svg";